"use client"

import SwiperMultiDevice from "@/ui/SwiperMultiDevice/SwiperMultiDevice"
import styled from "@emotion/styled"
import { Box } from "@mui/material"
import { Swiper, SwiperSlide } from "swiper/react"
import { colors, mediaQueries, sizes } from "ui/theme/theme"
import BlockWrapper from "../../common/BlockWrapper"

export const StyledSwiperMultiDevice = styled(SwiperMultiDevice)`
  .swiper {
    overflow: hidden;
  }
`

export const StyledBlockWrapper = styled(BlockWrapper)`
  padding-top: 50px;
  .image-gallery-swiper .swiper {
    overflow: hidden !important;
  }
`

export const GalleryContainer = styled(Box)`
  width: 100%;
  max-width: 1200px;
  position: relative;
  margin: 0 auto;
  ${mediaQueries.tabletDown} {
    padding: 0 ${sizes.baseSingle};
  }
`

export const StyledSwiper = styled(Swiper)`
  width: 100%;
  margin-bottom: ${sizes.baseTriple};

  .swiper-wrapper {
    align-items: center;
  }

  .swiper-slide {
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .swiper-pagination {
    position: relative;
    margin-top: ${sizes.baseDouble};

    .swiper-pagination-bullet {
      width: 14px;
      height: 14px;
      background: transparent;
      border: solid 1px ${colors.red};
      opacity: 1;
    }

    .swiper-pagination-bullet-active {
      background: ${colors.red};
    }
  }
`

export const StyledSwiperSlide = styled(SwiperSlide)`
  position: relative;
  width: 100%;

  img {
    width: 100%;
    object-fit: contain;
    transition: transform 0.3s ease;
    border-radius: ${sizes.borderRadius};
  }

  &:hover img {
    transform: scale(1.02);
  }
`

export const ImageContainer = styled(Box)`
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  background-color: ${colors.lightestGray};
  border-radius: ${sizes.borderRadius};
  overflow: hidden;
`

export const ThumbnailsContainer = styled(Box)`
  display: flex;
  justify-content: center;
  gap: ${sizes.baseSingle};
  margin-top: ${sizes.baseDouble};
  flex-wrap: wrap;

  ${mediaQueries.mobile} {
    gap: 8px;
  }
`

export const ThumbnailItem = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isActive",
})<{ isActive?: boolean }>`
  position: relative;
  width: 80px;
  height: 60px;
  border-radius: ${sizes.baseSingle};
  overflow: hidden;
  cursor: pointer;
  opacity: ${(props) => (props.isActive ? 1 : 0.6)};
  border: ${(props) => (props.isActive ? `2px solid ${colors.red}` : "none")};
  transition: all 0.3s ease;

  &:hover {
    opacity: 1;
  }

  ${mediaQueries.mobile} {
    width: 60px;
    height: 45px;
  }
`

export const ButtonsContainer = styled(Box)`
  display: flex;
  justify-content: center;
  gap: ${sizes.baseDouble};
  margin-top: ${sizes.baseTriple};

  ${mediaQueries.mobile} {
    margin-top: ${sizes.baseDouble};
  }
`

export const StyledArrowIconWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  z-index: 1;
  cursor: pointer;
  width: 48px;
  height: 48px;

  &.swiper-button-prev {
    transform: rotate(180deg);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  svg {
    width: 48px;
    height: 48px;
    ${mediaQueries.desktopXl} {
      width: 52px;
      height: 52px;
    }
  }
`

export const GalleryCaption = styled(Box)`
  text-align: center;
  margin-top: ${sizes.baseDouble};
  padding: 0 ${sizes.baseDouble};
  color: ${colors.black};

  ${mediaQueries.mobile} {
    padding: 0 ${sizes.baseSingle};
  }
`
